import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import moon from '../assets/img/svg/moon.svg'
import verified from '../assets/img/svg/verified.svg'
import user from '../assets/img/svg/user-1.svg'

import TinySlider from "tiny-slider-react";
import '../../node_modules/tiny-slider/dist/tiny-slider.css'
import { deleteSpace } from '../services/ApiServices'
import toast from 'react-hot-toast'
import move from '../assets/img/move.svg'

const settings = {
    items: 1,
    controls: false,
    mouseDrag: true,
    loop: true,
    rewind: true,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    navPosition: "bottom",
    nav: true,
    speed: 400,
    gutter: 0,
};

export interface listPropertyProp {
    item: any;
    isEditable: boolean;
    mySpaceAPICall?: any;
}

export default function ListProperty({ item, isEditable, mySpaceAPICall }: listPropertyProp) {
    var navigate = useNavigate();

    const [isShowDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const formatNumber = (value: string) => {
        return parseFloat(value).toString();
    };


    const amountFormatter = (amount: any) => {
        const formattedAmount = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
            maximumFractionDigits: 2,
        }).format(amount);
        console.log("formattedAmount", formattedAmount);

        return formattedAmount;
    };

    var price: any;
    var sfPrice: any;
    if (item?.price) {
        if (item?.square_feet > 0) {
            price = `${amountFormatter(item.square_feet)} SF`
        }
    } else {
        if (item?.square_feet) {
            price = `${amountFormatter(item.square_feet)} SF`
        }
        if (item?.price_per_square) {
            sfPrice = `${formatNumber(item.price_per_square)} PSF`
        } else {
            sfPrice = `$${formatNumber(item.monthly_rent)} Mth`
        }
    }
    const handleDeleteSpace = () => {
        const data = new FormData();
        data.append("space_id", item.id)
        deleteSpace(data).then((res) => {
            console.log("delete space deleted", res);
            if (res?.status === "success") {
                toast.success(res.message);
                setShowDeleteModal(false)
                mySpaceAPICall()
            }
        }).catch((err) => {
            console.log("error deleting space", err);

        })
    }
    return (
        <div className="property-listing list_view style_new">
            <div className="listing-img-wrapper position-relative">
                <div className="position-absolute top-0 left-0 ms-3 mt-3 z-1">
                    {/* {item.tag.map((el: any, index: number) => {
                        return (

                            <div key={index} className={`label text - light d - inline - flex align - items - center justify - content - center mx - 1 ${ el === 'Verified' ? 'bg-success' : '' } ${ el === 'SuperAgent' ? 'bg-purple' : '' } ${ el === 'New' ? 'bg-danger' : '' } `}>
                                {el === 'Verified' && <img src={verified} alt="" className='me-1' />}

                                {el === 'SuperAgent' && <img src={user} alt="" className='me-1' />}

                                {el === 'New' && <img src={moon} alt="" className='me-1' />}
                                {el}
                            </div>
                        )
                    })} */}
                </div>
                <div className="list-img-slide" style={{ backgroundColor: "Highlight", width: "100%" }}>
                    {/* <div ><Link to="#"><img src={require("../assets/img/p-1.jpg")} className="img-fluid mx-auto" alt="" /></Link></div> */}
                    <div style={{ width: "100%" }}><Link to="#"><img src={item?.image} className="img-fluid mx-auto" alt="" style={{ objectFit: "contain" }} /></Link></div>
                    {/* <TinySlider settings={settings}>
                            {item.image.map((el: any, index: number) => {
                                return (
                                    <div key={index}><Link to="#"><img src={el} className="img-fluid mx-auto" alt="" /></Link></div>
                                )
                            })}
                        </TinySlider> */}
                </div>
            </div>

            <div className="list_view_flex" style={{ width: "50%" }}>

                <div className="listing-detail-wrapper mt-1">
                    <div className="listing-short-detail-wrap">
                        <div className="_card_list_flex mb-2">
                            <div className="_card_flex_01 d-flex align-items-center">
                                {<span className="label bg-light-success text-success me-2">{item.monthly_rent ? "For Lease" : "For Sale"}</span>}
                                {/* {item.price_per_square && <span className="label bg-light-danger text-danger me-2">For Sell</span>} */}
                                {/* <span className="label bg-light-purple text-purple">{item.type}</span> */}
                            </div>
                            <div className="_card_flex_last">
                                <h6 className="listing-info-price text-primary fs-4 mb-0">{item.value}</h6>
                            </div>
                        </div>
                        <div className="_card_list_flex">
                            <div className="_card_flex_01">
                                <h4 className="listing-name mt-3  cursor-none">{item?.address}  </h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="price-features-wrapper">
                    <div className="list-fx-features d-flex align-items-center justify-content-between">
                        <div className="listing-card d-flex align-items-center">
                            <div className="square--30 text-muted-2 fs-sm circle gray-simple me-2"><i className="fa-solid fa-building-shield fs-sm"></i></div><span className="text-muted-2">{item.property_type}</span>
                        </div>
                        <div className="listing-card d-flex align-items-center">
                            <div className="square--30 text-muted-2 fs-sm circle gray-simple me-2"><img src={move} width="13" alt="" /></div><span className="text-muted-2">{price}</span>
                        </div>
                        <div className="listing-card d-flex align-items-center">
                            {sfPrice && <><div className="square--30 text-muted-2 fs-sm circle gray-simple me-2"><i className="fa-solid fa-clone fs-sm"></i></div><span className="text-muted-2">{sfPrice}</span></>}
                            {/* {!sfPrice && <AmountFormatter amount={item.price} />} */}
                            {!sfPrice && <><div className="square--30 text-muted-2 fs-sm circle gray-simple me-2"><i className="fa-solid fa-clone fs-sm"></i></div><span className="text-muted-2">{`$${amountFormatter(item.price)}`}</span></>}
                        </div>
                    </div>
                </div>

                <div className="listing-detail-footer d-flex align-items-center justify-content-between">
                    <div className="footer-first">
                        <div className="foot-rates">
                            {/* <span className="elio_rate perfect">4.7</span>
                            <div className="_rate_stio">
                                <i className="fa fa-star" style={{ margin: '0 2px' }}></i>
                                <i className="fa fa-star" style={{ margin: '0 2px' }}></i>
                                <i className="fa fa-star" style={{ margin: '0 2px' }}></i>
                                <i className="fa fa-star" style={{ margin: '0 2px' }}></i>
                                <i className="fa fa-star" style={{ margin: '0 2px' }}></i>
                            </div> */}
                        </div>
                    </div>
                    {isEditable ? <div className="footer-flex">
                        <button className="btn btn-md btn-primary fw-medium me-2" onClick={() => navigate("/add-space", { state: item })}>Edit Property</button>
                        <button className="btn btn-md btn-danger fw-medium" onClick={() => setShowDeleteModal(true)}>Delete Property</button>
                    </div> :
                        <div className="footer-flex">
                            <button className="btn btn-md btn-primary fw-medium me-2" onClick={() => navigate(`/property-details/${item?.id}`,)}>View Property</button>
                        </div>
                    }
                </div>
            </div>
            {
                isShowDeleteModal &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setShowDeleteModal(!isShowDeleteModal)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">

                                <div className="modal-body">
                                    <h4 className="modal-header-title" style={{ fontSize: 25 }}>Delete Space</h4>
                                    <div className="d-flex align-items-center justify-content-center mb-3">
                                        <span>Are you sure you want to delete sapce?</span>

                                        {/* <span className="svg-icon text-primary svg-icon-2hx">
                                        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.8797 15.375C15.9797 15.075 15.9797 14.775 15.9797 14.475C15.9797 13.775 15.7797 13.075 15.4797 12.475C14.7797 11.275 13.4797 10.475 11.9797 10.475C11.7797 10.475 11.5797 10.475 11.3797 10.575C7.37971 11.075 4.67971 14.575 2.57971 18.075L10.8797 3.675C11.3797 2.775 12.5797 2.775 13.0797 3.675C13.1797 3.875 13.2797 3.975 13.3797 4.175C15.2797 7.575 16.9797 11.675 15.8797 15.375Z" fill="currentColor"></path>
                                            <path opacity="0.3" d="M20.6797 20.6749C16.7797 20.6749 12.3797 20.275 9.57972 17.575C10.2797 18.075 11.0797 18.375 11.9797 18.375C13.4797 18.375 14.7797 17.5749 15.4797 16.2749C15.6797 15.9749 15.7797 15.675 15.7797 15.375V15.2749C16.8797 11.5749 15.2797 7.47495 13.2797 4.07495L21.6797 18.6749C22.2797 19.5749 21.6797 20.6749 20.6797 20.6749ZM8.67972 18.6749C8.17972 17.8749 7.97972 16.975 7.77972 15.975C7.37972 13.575 8.67972 10.775 11.3797 10.375C7.37972 10.875 4.67972 14.375 2.57972 17.875C2.47972 18.075 2.27972 18.375 2.17972 18.575C1.67972 19.475 2.27972 20.475 3.27972 20.475H10.3797C9.67972 20.175 9.07972 19.3749 8.67972 18.6749Z" fill="currentColor"></path>
                                        </svg>
                                    </span> */}
                                    </div>
                                    <div className="form-group d-flex">
                                        <button type="button" className="btn btn-md btn-outline-primary fw-medium full-width rounded-2 me-2" onClick={() => setShowDeleteModal(!isShowDeleteModal)}>Cancel</button>
                                        <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => handleDeleteSpace()}>Delete Space</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>

    )
}
